import { render } from "./SelectFile.vue?vue&type=template&id=01f43f18"
import script from "./SelectFile.vue?vue&type=script&lang=js"
export * from "./SelectFile.vue?vue&type=script&lang=js"

import "./SelectFile.vue?vue&type=style&index=0&id=01f43f18&lang=scss"

import exportComponent from "/builds/root/lvgou_pub_mob/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__